export default __webpack_public_path__ + "static/media/40.1ba69be2.png";